import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { motion } from "framer-motion";
import { functionalControlAccordion } from "../../data/data";
import { useTranslation } from "react-i18next";

const FunctionalControl = () => {
  const [expanded, setExpanded] = useState<number | null>(0);
  const { t } = useTranslation();

  const handleChange =
    (index: number) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? index : null);
    };

  return (
    <section className="relative w-full h-full">
      <div className="w-full bg-[#F2F6F7] px-[5%]">
        <div className="pt-8 sm:pt-12 pb-8 maxContainer">
          <h2 className="mt-2 mb-5 font-bold leading-tight text-[28px] ss:text-md md:text-lg md:max-w-[599px] tracking-wide">
            {t("services.functional_control_page_heading")}
          </h2>
          <p className="md:text-[18px] text-greyText">
            {t("services.functional_control_page_description")}
          </p>
        </div>
      </div>
      <div className="w-full bg-[#fafafa] px-[5%]">
        <div className="pt-8 pb-12 sm:pt-12 sm:pb-16 maxContainer">
          <h4 className="mt-2 mb-5 font-bold leading-tight text-sm ss:text-md md:max-w-[879px] ">
            {t("services.functional_control_page_subheading")}
          </h4>
          {functionalControlAccordion.map((section, index) => (
            <Accordion
              key={index}
              expanded={expanded === index}
              onChange={handleChange(index)}
              className="mb-5 transition-all duration-500 ease-in-out border border-gray-200 rounded-lg shadow-md "
              sx={{
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    sx={{
                      color: expanded === index ? "#fff" : "#000",
                      transition: "color 0.3s ease-in-out",
                    }}
                  />
                }
                sx={{
                  backgroundColor: expanded === index ? "primary.main" : "#fff",
                  color: expanded === index ? "#fff" : "#000",
                  transition:
                    "background-color 0.3s ease-in-out, color 0.3s ease-in-out",
                  borderRadius: "8px",
                  padding: "10px 20px",
                }}
              >
                <h3 className="text-[20px] font-semibold">
                  {t(section.title)}
                </h3>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  transition: "height 0.5s ease-in-out",
                  overflow: "hidden",
                  paddingBottom: expanded === index ? "16px" : "0px",
                }}
              >
                <motion.ul
                  className="px-2 py-5 space-y-4"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                >
                  {section.items.map((item, idx) => (
                    <li
                      key={idx}
                      className="flex gap-4 text-gray-700 text-[16px] leading-relaxed"
                    >
                      <CheckCircleIcon
                        className="text-primary"
                        sx={{ fontSize: "22px" }}
                      />
                      {t(item)}
                    </li>
                  ))}
                </motion.ul>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FunctionalControl;
